"use client";

import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
} from "react";

import {
  BLOG_URL,
  LOYALTY_BLOG_URL,
  SHOP_URL,
} from "@/app/_internal/sitemap/consts";
import { env } from "@/env";

const RewriteUrlsContext = createContext<{
  shop?: string;
  blog?: string;
  ["loyalty-blog"]?: string;
}>({});

export const RewriteUrlsProvider: FC<PropsWithChildren<{ locale: string }>> = ({
  children,
  locale,
}) => {
  const rewriteConfig = env.rewriteUrls?.[locale];

  return (
    <RewriteUrlsContext.Provider value={rewriteConfig}>
      {children}
    </RewriteUrlsContext.Provider>
  );
};

export const useRewriteUrls = (): {
  shop: string;
  blog: string;
  loyaltyBlog: string;
} => {
  const rewriteUrlsConfig = useContext(RewriteUrlsContext);

  return useMemo(
    () => ({
      shop: rewriteUrlsConfig?.shop || SHOP_URL,
      blog: rewriteUrlsConfig?.blog || BLOG_URL,
      loyaltyBlog: rewriteUrlsConfig?.["loyalty-blog"] || LOYALTY_BLOG_URL,
    }),
    [rewriteUrlsConfig]
  );
};
